import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";

const RadioButtonCard = ({
  name,
  title,
  items,
  value,
  setValue,
  clearErrors,
  onChange,
  errors,
}) => {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    setValue(name, value);
  }, [value, name, setValue]);

  const handleChange = (value) => {
    setSelected(value);
    clearErrors(name);
    setValue(name, value);
    if (onChange) onChange(value);
  };

  return (
    <>
      <RadioGroup
        name={name}
        value={selected}
        onChange={(value) => handleChange(value)}
      >
        <RadioGroup.Label className="form-label">{title}</RadioGroup.Label>
        <div className="grid grid-flow-col space-x-3 pt-1">
          {items.map((item) => (
            <RadioGroup.Option
              key={item.id}
              value={item.value}
              className={({ checked }) =>
                `${
                  checked ? "border-blue-400" : "border-gray-200"
                } col-span-1 border relative rounded-md px-5 py-4 cursor-pointer focus:outline-none`
              }
            >
              {item.content}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default RadioButtonCard;
